export const siteConfig = {
  email: 'info@keevo.se',
  organisationNumber: '',
  vatNumber: '',
  social: {
    tiktok: '',
    instagram: '',
    linkedin: '',
    youtube: '',
  },
} as const;
